import { BONUS_BY_PRODUCT_CARDS_ES_MX } from "#components/bonus-by-product-cards/translations";
import { BONUS_BY_PRODUCT_TABLE_ES_MX } from "#components/tables/reports/bonus-by-product-table/translations";
import { merge } from "lodash-es";

export const financialReport = {
	print: "Imprimir informe",
	letterhead: 'Emitido por "{{name}} a las {{momentLT}} el {{momentL}}"',
	menu: {
		financialReport: "Cierre",
		promotionsReports: "Promociones utilizadas",
		salesTotemTransaction: "Ventas por transacciones Totem",
		debtorsReport: "Cuentas abiertas",
		devolutionReport: "Devolución de tarjeta por caja",
		cashierClose: "Cierre de caja",
		bonusReport: "Bonos",
		discountsReportForPlace: "Descuentos en cuenta",
		refundedProductsReport: "Productos reembolsados",
		seeRefundReports: "Servicios eliminados",
		bonusByProduct: "Bonos por producto",
		openedBillPayment: "Pago de cuentas abiertas",
		reserveReport: "Informe de paquetes",
		rappiDiscountsReport: "Descuentos Rappi",
		consumptionObligationReport: "Consumo mínimo",
		minimumConsumptionReport: "Consumo anticipado",
		openSalesReport: "Ventas individuales",
		cashierAdjustmentsReport: "Retiros y Fondos de Cambio",
		zigAppTransactions: "Ventas por transacciones del Zig.app",
		transactionTransfer: "Transferencias de cuentas",
	},
	tabs: {
		financialReport: {
			title: "Financiero de {{placeName}}",
			seeAllPaymentsButton: "Ver todos los pagos",
			analyticPayments: {
				title: "Informe Analítico",
				columns: {
					date: "Fecha",
					author: "Empleado",
					client: "Cliente",
					method: "Método",
					value: "Valor",
				},
				searchName: "Buscar por cliente o empleado...",
				searchMethod: "Seleccione un método...",
				bonus: "Bonos por producto",
				filename: "informe-analitico",
			},
			cmv: {
				title: "CMV",
				name: "Nombre",
				value: "Valor",
				valuesName: "Costo total de mercancía vendida",
			},
			goTo: "ir a",
			filename: "informe_cierre",
			columnSection: {
				value: "valor",
				receipt: "ingreso",
				percentage: "porcentual",
				quantity: "cantidad",
			},
		},
		salesTotemTransaction: {
			columns: {
				date: "Fecha",
				author: "Empleado",
				client: "Cliente",
				method: "forma de pago",
				operator: "Operador",
				totem: "Totem",
				value: "Valor de la venta",
				details: "Detalles",
			},
			details: {
				title: "Detalles de la transacción",
				refunded: "Reembolsado",
				products: "Productos",
				transactionId: "Id de la transacción",
				zigId: "Id de zig",
				close: "Cerrar",
			},
			totalizer: {
				totalClients: "Total de clientes",
				paymentWithBalance: "Pago con saldo",
				totalSales: "Total en ventas",
				searchByIdOrCpf: "Busque por ID o RFC",
				paymentMethod: "Forma de pago",
				totemLabel: "Totem",
				enterOrSelectTotem: "Escriba o seleccione el totem",
			},
			paymentMethodDetails: {
				CreditCard: "Tarjeta de Crédito",
				DebitCard: "Tarjeta de Débito",
				Cash: "Efectivo",
				PostEvent: "Post Evento",
				ZigPosCredit: "ZigPos Crédito",
				ZigPosDebit: "ZigPos Débito",
				Voucher: "Voucher",
				Bonus: "Bono",
				Pix: "Pix",
				IntegratedFoodVoucher: "Voucher de Alimentación Integrado",
				ZigPosCreditInInstallments: "ZigPos Crédito en Cuotas",
				Anticipated: "Anticipado",
				Ame: "Ame",
				MBWay: "MBWay",
			},
		},
		promotionsReports: {
			title: "Promociones utilizadas de {{placeName}}",
			promotionReportLabel: "Promociones utilizadas",
			promotionReportFileName: "promociones-utilizadas",
			userPromotionReportLabel: "Utilizadas por personas",
			tablePromotionReportLabel: "Utilizadas por Mesas",
			tableTite: "Mesa",
			promotionTitle: "Promociones",
			tablePlaceholder: "Todos",
			userPromotionReportFileName: "promociones-utilizadas-por-persona",
			totalDiscount: "Total de descuento",
			totalUses: "Total de uso",
			columns: {
				userName: "Nombre",
				userDocument: "RFC",
				productName: "Producto",
				promotionName: "Promoción",
				productCategory: "Categoría",
				uses: "Cantidad de usos",
				totalDiscount: "Descuento total",
			},
		},
		tableReports: {
			title: "Promociones utilizadas de {{placeName}}",
			promotionReportLabel: "Promociones utilizadas",
			promotionReportFileName: "promociones-utilizadas",
			userPromotionReportLabel: "Utilizadas por personas",
			tablePromotionReportLabel: "Utilizadas por Mesas",
			userPromotionReportFileName: "promociones-utilizadas-por-persona",
			totalDiscount: "Total de descuento",
			tablePlaceholder: "Todos",
			totalUses: "Total de uso",
			columns: {
				userName: "Nombre",
				productName: "Producto",
				promotionName: "Promociones",
				productCategory: "Categoría",
				uses: "Cantidad de usos",
				totalDiscount: "Descuento total",
				openedAt: "Apertura",
				closedAt: "Cierre",
			},
		},
		debtorsReport: {
			title: "Cuentas abiertas",
			goTo: "ir a",
			clientInfo: "Información de Cliente",
			filename: "cuentas-abiertas",
			clientTotal_one: "Total ({{debtors}} cliente)",
			clientTotal_other: "Total ({{debtors}} clientes)",
			modalTitleName: "Pago de {{userName}}",
			modalTitleDebts: "Pago de {{debts}} cuentas",
			columns: {
				username: "Nombre",
				document: "RFC",
				phone: "Teléfono",
				date: "Fecha",
				value: "Abierto en cuenta",
				tipValue: "Abierto en servicio",
				totalOpen: "Total abierto",
				paidValue: "Pagado después del evento",
				stillOpen: "Aún abierto",
				filters: {
					paid: "Ya pagado",
					unpaid: "No pagado",
				},
				others: {
					allBillsPaid: "Todas las cuentas pagadas",
					payAllBills: "Pagar todas las cuentas",
					paid: "Ya pagado",
					paymentOptions: "Opciones de pago",
					pixCharge: "Generar cobro vía PIX",
				},
				status: {
					title: "Estado de cobro",
					paid: "Pagado",
					unpaid: "Por pagar",
				},
			},
			search: "Buscar cliente...",
			paymentLink: {
				sendCharge: "Cobrar",
				generatedLink: "Link generado",
				charged: "Cobrado",
				noReturn: "Sin retorno",
				cancel: "Cancelar",
				discharge: "Dar de baja",
				chooseShippingMethod: "Elija el método de envío",
				finalPaymentLink: "Copie el link para control o para enviar en otro momento",
				error: "El número proporcionado por el cliente no tiene Whatsapp.",
				details: "Detalles {{userName}}",
				openValues: "Valores abiertos",
				openConsumption: "Consumo abierto",
				totalDebit: "Total abierto",
				tip: "servicio",
				mail: "E-mail",
				phone: "Teléfono",
				consumedProducts: "Productos consumidos",
				viewBillingDetails: "Ver detalles",
				copyError: "Error al copiar link",
				copySuccess: "Copiado con éxito",
				status: {
					created: "Link generado",
					notCharged: "No cobrado",
					expired: "Sin respuesta",
					partiallyCreated: "Parcialmente cobrado",
				},
				whatsappMessage:
					"Hola {{userName}}, esperamos que esté todo bien. Nos gustaría informarle que tiene una cuenta pendiente en {{placeName}}." +
					" Para su comodidad, hemos habilitado un link de pago seguro donde puede efectuar el pago de forma rápida y fácil: " +
					"{{link}} . Si ya realizó el pago, por favor ignore este mensaje. De lo contrario, agradecemos anticipadamente su cooperación en resolver esta pendiente.",
				emailError: "Error al enviar el email",
				emailSuccess: "Email enviado con éxito",
				paidBillMessage: "No es posible cobrar una cuenta pagada",
				resendBill: "Reenviar",
				statusTooltip: {
					created: "Link de cobro generado para este cliente.",
					notCharged: "Ningún link fue generado para cobrar a este cliente",
					partiallyCreated:
						"Existe un link de cobro generado para este cliente, pero tiene otra cuenta abierta en el período que no fue cobrada en el link anterior",
					expired:
						"El link de pago fue generado hace más de 7 días y no fue pagado hasta el momento",
				},
				selectService: "¿Desea incluir la tarifa de servicio en el valor abierto?",
				selectServiceText:
					"Al elegir incluir la tarifa de servicio, el valor de la tarifa será agregado al valor abierto de la cuenta.",
				dontIncludeService: "No incluir ",
				includeService: "Incluir tarifa de servicio",
				seeMore: "Ver más",
				copyLink: "Copiar link del cobro",
				copyValidLink: "Asegúrese de que este es un link válido",
				retrieveLink: "Recuperar link de cobro",
				moreOptions: "Más opciones",
				confirmRemoveTip:
					"Al remover el servicio del cobro vía link, el valor será puesto en cero y no podrá ser retomado.",
				wishToProceed: "¿Desea continuar?",
			},
		},
		devolutionReport: {
			title: "Devolución de tarjeta por caja",
			filename: "devolucion-de-tarjeta-por-caja",
			sheetTitle: "Devolución de tarjeta {{sheetName}}",
			filenameCard: "devolucion-de-tarjeta",
			total: "Total",
			totalCategory: "Total ({{category}})",
			totalGeral: "Total general",
			cashier: "Por cajas",
			cashDevolution: "Devolución en efectivo",
			devolution: "Devolución en {{method}}",
			devolutions: "{{value}} devoluciones",
			columns: {
				employee: "Empleado",
				quantity: "Cantidad",
				value: "Valor",
				type: "Tipo",
			},
		},
		cashierClose: {
			title: "Cierre de caja",
			resume: "Resumen",
			cashiers: "Cajas",
			search: "Buscar caja",
			searchBars: "Buscar bares",
			excelExport: "Exportar a excel",
			changeFund: "Fondo de cambio",
			modality: "Modalidad",
			billed: "Facturado",
			closed: "Cerrado",
			difference: "Diferencia",
			methods: {
				cash: "Efectivo",
				debit: "Débito",
				credit: "Crédito",
				voucher: "Voucher",
				zigDebit: "Zig Débito",
				zigCredit: "Zig Crédito",
				postEvent: "Después del evento",
				dashboard: "Dashboard",
				anticipated: "Anticipado",
				deliveryOnline: "Delivery Online",
				ame: "Ame",
				rappi: "Rappi",
				uber: "Uber",
				ifood: "Ifood",
				pix: "Pix",
				bonus: "Bonus",
				installment: "En cuotas",
				foodVoucher: "Vale de comida",
			},
			hawkers: "Ambulantes",
			hawkerCashier: "Caja de Ambulantes",
		},
		bonusReport: {
			subtitle: "Aquí puede visualizar todos los bonos dados por empleados.",
			title: "Bonos",
			description: "Vea todos los informes de concesión y uso de bonos",
			filenameBonus: "bono-concedido",
			filenameAnticipated: "consumo-anticipado",
			filenameConsumption: "consumo",
			total: "Total de {{category}}",
			select: "Seleccione una categoría",
			selectNotFound: "Ninguna categoría encontrada",
			tabs: {
				given: "Bono Concedido",
				used: "Bono Utilizado",
			},
			usedBonus: "Bonos Utilizados",
			columns: {
				client: "Empleado Responsable",
				category: "Categoría",
				date: "Fecha",
				dateTime: "Fecha y Hora",
				reason: "Motivo",
				receivedValue: "Valor recibido",
				spentValue: "Valor gastado en el período",
				spentValueInOtherEvents: "Valor gastado en otro período",
				spentValueInBonus: "Valor del Pago en Bono",
				givenBy: "Dado por",
				total: "Total",
			},
		},
		discountsReportForPlace: {
			title: "Descuentos utilizados de {{placeName}}",
			discounts: "Descuentos",
			filename: "descuentos",
			columns: {
				employee: "Empleado",
				date: "Fecha",
				clients: "Clientes",
				justify: "Justificación",
				category: "Categoría",
				products: "Productos",
				percentage: "Porcentaje",
				discount: "Descuento",
				total: "Total",
			},
			filter: "Filtrar por categoría",
			selectCategory: "Elegir la categoría",
		},
		refundedProductsReport: {
			title: "Productos reembolsados",
			titleRecharges: "Recargas reembolsadas",
			filenameRecharges: "recargas-reembolsadas",
			columns: {
				date: "Fecha",
				client: "Cliente",
				author: "Recarga hecha por",
				refundedBy: "Reembolsado por",
				totalValue: "Valor total",
				usedValue: "Valor utilizado",
			},
		},
		seeRefundReports: {
			title: "Eliminación de servicios por caja",
			printButton: "Imprimir informe",
			exportButton: "Exportar informe",
		},
		bonusByProduct: merge(
			{
				cards: BONUS_BY_PRODUCT_CARDS_ES_MX,
			},
			BONUS_BY_PRODUCT_TABLE_ES_MX,
		),
		openedBillPayment: {
			title: "Pagos de cuentas abiertas",
			tooltip: "Información del cliente",
			columns: {
				date: "Fecha de pago",
				client: "Cliente",
				document: "RFC",
				openedEventDate: "Fecha de la cuenta abierta",
				employee: "Pagado a",
				method: "Método",
				value: "Valor",
				total: "Total",
				observation: "Observación",
				tipValue: "Valor de propina",
			},
			mixed: "Mixto",
			emptyText: "Sin datos para mostrar.",
		},
		reserveReport: {
			title: "Paquetes",
			withoutPackage: "Ningún paquete activo durante el período",
			onePackage: "Un paquete activo durante el período",
			manyPackages: "{{quantity}} paquetes activos durante el período",
			columns: {
				name: "Nombre del paquete",
				products: "Productos",
				invitedPeople: "Invitados",
				confirmedPeople: "Confirmados",
				value: "Valor del paquete",
				revenue: "Facturación total",
				issued: "Emisión de NF",
			},
			moreDetails: "Más detalles",
			total: "Total",
			totalCategory: "Total ({{category}})",
		},
		consumptionObligationReport: {
			title: "Consumo Mínimo",
			filename: "consumo-minimo",
			filenameObligation: "obligacion-de-consumo",
			columns: {
				date: "Fecha",
				client: "Cliente",
				employee: "Dado por",
				value: "Valor",
				userProductsValueAtEvent: "Utilizado en productos",
				paidValue: "Sobrante de consumo",
				total: "Total",
			},
		},
		minimumConsumptionReport: {
			title: "Consumo anticipado",
		},
		openSalesReport: {
			title: "Informe de ventas individuales",
			searchPlaceholder: "Buscar por nombre del empleado",
			employeeSales: "Ventas individuales de {{employeeName}}",
			columns: {
				employee: "Empleado",
				total: "Total",
				date: "Fecha",
				isRefunded: "Fue reembolsada",
				refundedBy: "Reembolsada por",
				refundedAt: "Reembolsada en",
				value: "Valor",
				method: "Método",
				yes: "sí",
				no: "no",
			},
			seeAllSales: "Ver todas las ventas",
			totalSales: "Total de ventas individuales",
		},
		rappiDiscountReport: {
			title: "Descuentos de Rappi",
			sheet: {
				filename: "informe_de_descuentos_de_rappi",
				title: "Descuentos de Rappi",
				columns: {
					products: "Productos",
					date: "Fecha",
					value: "Valor del descuento",
					employee: "Empleado que aplicó el descuento",
				},
			},
		},
		zigAppReport: {
			title: "Ventas por transacciones del Zig.app",
			searchByClientName: "Busque por nombre del cliente",
			paymentMethod: "Forma de pago",
			searchByIdOrCpf: "Busque por ID o RFC",
			totemLabel: "Totem",
			enterOrSelectTotem: "Escriba o seleccione el totem",
			balance: "Saldo",
			creditCard: "Tarjeta de crédito",
			refunded: "Reembolsado",
			creditCardPayment: "Pago tarjeta de crédito",
			paymentWithBalance: "Pago con saldo",
			averageTicket: "Ticket Promedio",
			totalSales: "Total en ventas",
			totalClients: "Total de clientes",
			date: "Fecha",
			client: "Cliente",
			clients: "clientes",
			operator: "Operador (PDV)",
			details: "Detalles",
			totalPeriod: "Total período",
			transactionDetail: "Detalles de la transacción",
			produtcs: "Productos",
			zigId: "ID de zig",
			transactionId: "ID de la transacción",
			copyTextSuccess: "¡Id copiado con éxito!",
			total: "Total pagado con Zig.app",
			service: "Servicio",
			close: "Cerrar",
			justification: "Justificación",
			refundTransaction: "Reembolsar transacción",
			cancelTransaction: "Cancelar transacción",
			optional: "Opcional",
			charactersLimit: "Hasta 150 caracteres",
			inputCancelationPlaceholder: "Escriba el motivo del reembolso",
			cancelAlertMessage:
				"Al cancelar, los productos volverán al inventario y la acción NO podrá ser deshecha. ¿Desea continuar de todos modos?",
			serviceCharge: "Tarifa de servicio",
			status: "Estado",
			selectRefundProductsList: "Productos:",
			shouldGoBackToStock: "¿Los productos deben volver al inventario?",
			inputJustificationPlaceholder: "Escriba el motivo del reembolso",
			refundAdlertMessage:
				"Al reembolsar, los productos NO VOLVERÁN al inventario y la acción NO podrá ser deshecha. ¿Desea continuar de todos modos?",
		},
		salesTotetemTransaction: {
			title: "Ventas por transacciones del Totem",
			subtitle:
				"Dé seguimiento a las transacciones realizadas por sus clientes usando un totem del evento.",
		},
		transactionTransferReport: {
			title: "Transferencias de cuentas",
			fileName: "transferencias_de_cuentas",
			columns: {
				originCardId: "ID de origen",
				receiverCardId: "ID de la tarjeta que recibió",
				originDocument: "RFC/Mesa de origen",
				receiverDocument: "RFC/Mesa de destino",
				productValue: "Valor del producto",
				productDiscountValue: "Descuento",
				productName: "Nombre del producto",
				employeeName: "Operador",
				date: "Horario",
			},
		},
	},
	getSubTitle: "De {{since}} hasta {{until}}",
};
